import type maplibregl from "maplibre-gl";
import type { StyleValue } from "../types";

type Props = {
	cases: Array<[condition: maplibregl.ExpressionSpecification, value: StyleValue]>;
	fallback: StyleValue;
};

function buildCaseExpression({ cases, fallback }: Props): maplibregl.ExpressionSpecification {
	if (cases.length === 0) {
		return fallback as unknown as maplibregl.ExpressionSpecification;
	}

	return ["case", ...cases.flat(), fallback] as unknown as maplibregl.ExpressionSpecification;
}

export { buildCaseExpression };
